module.exports = __webpack_public_path__ + "static/assets/24494d797d4aa64939e9fec9ca9f5fec.svg";